module.exports = __webpack_public_path__ + "media/images/hodzzy-usecase-4b8ba17f2cb5ddc876f033d64793d8a7.png";